import { useGetBillingUnitsForAdmin } from '@dhl/mdp-api'
import { type AdminBillingUnit } from '~/modules/adminusers/model'

export const useAdminBillingUnits = (adminUserId: string) => {
  const { data, isFetching, refetch } = useGetBillingUnitsForAdmin(adminUserId, undefined)
  const billingUnits: AdminBillingUnit[] = (data?.content ?? []).flatMap((b) =>
    b.id ? [{ id: b.id, cccId: b.cccId, name: b.name }] : []
  )
  return { billingUnits, isLoading: isFetching, refetch }
}
